import React, { useMemo, useState } from 'react';
import { getCoreRowModel } from '@tanstack/react-table';

// MUI Theme
import { Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

// Utils
import { makeMobileUserLogColumn } from '../../../../utils/columns/makeMobileUserLogColumn';
import { getMobileLogsByImei } from '../../../../services/user.service';

// Types
import { FilterableTypes } from '../../../../types/FilterableTypes';

// Components
import { Table, useNewTable } from '../../../common/table/index';

interface MobileLogsProp {
  imei: string;
  accessKey?: string;
}

const useStyles = makeStyles(() => ({
  toggleButtonGroup: {
    height: '30px',
    padding: 2,
    backgroundColor: 'white',
  },
  toggleButton: {
    '&.MuiToggleButton-root': {
      fontSize: 'xx-small',
      whiteSpace: 'nowrap',
    },
  },
}));

const UserMobileLogs = (props: MobileLogsProp): JSX.Element => {
  const classes = useStyles();
  const [toggleSeverity, setToggleSeverity] = useState('-1');

  const [paramFilter, setParamFilter] = useState<any>({
    sortBy: [
      {
        timestamp: '-1',
      },
    ],
    filters: [{ imei: props.imei, filterType: FilterableTypes.Equals }],
  });

  const columns = useMemo(() => makeMobileUserLogColumn(), []);

  const table = useNewTable<any>({
    columns,
    accessKey: props.accessKey,
    fetchAsync: getMobileLogsByImei,
    params: paramFilter,
    serverSide: true,
  });

  const handleSeverityButton = (event: React.MouseEvent<HTMLElement>, value: string) => {
    setToggleSeverity(value);
    const filterParams = {
      sortBy: [...paramFilter.sortBy],
      filters: [{ imei: props.imei, filterType: FilterableTypes.Equals }],
      take: 1000,
    };

    if (value !== '-1') {
      filterParams.filters.push({
        severity: value,
        filterType: FilterableTypes.Equals,
      } as any);
    }

    setParamFilter(filterParams);
  };

  return (
    <>
      <div>
        <ToggleButtonGroup
          value={toggleSeverity}
          exclusive
          onChange={handleSeverityButton}
          aria-label='Small sizes'
          className={classes.toggleButtonGroup}
          style={{ marginBottom: 5, marginTop: 2 }}
        >
          <ToggleButton value='-1' aria-label='centered' className={classes.toggleButton}>
            All
          </ToggleButton>
          <ToggleButton value='0' aria-label='centered' className={classes.toggleButton}>
            Info
          </ToggleButton>
          <ToggleButton value='1' aria-label='centered' className={classes.toggleButton}>
            Warning
          </ToggleButton>
          <ToggleButton value='3' aria-label='centered' className={classes.toggleButton}>
            Alert
          </ToggleButton>
        </ToggleButtonGroup>
      </div>

      <Paper>
        <Table
          {...table}
          showSearchBar={false}
          showColumnToggler={false}
          showAction={false}
          showSpinner={false}
          getCoreRowModel={getCoreRowModel()}
        />
      </Paper>
    </>
  );
};

export default UserMobileLogs;
